import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import LandingPage from '../pages/LandingPage'
import OpenRoute from './OpenRoutes'
import ComponentsPage from '../pages/Components'
import Login from '../pages/auth/Login'
import Signup from '../pages/auth/Signup'
import VerifyEmail from '../pages/auth/VerifyEmail'
import ForgotPasswordPage from '../pages/auth/ForgotPassword'
import ResetPasswordPage from '../pages/auth/ResetPassword'
import WaitingListPage from '../pages/WaitListPage'
import Main from '../components/Layout/Main'
import {
  extraSideNavItems,
  mainSideNavItems,
  SideNavItemType,
} from '../components/SideNav/sidebarData'
import Dashboard from '../pages/Dashboard'
import FaqPage from '../pages/LandingPage/Faq'
import ContactPage from '../pages/LandingPage/Contact'
import AboutPage from '../pages/About'
import Settings from '../pages/Settings'
import PrivacyPolicyPage from '../pages/Privacy'
import AddFeedback from '../pages/Feedback/Addfeedback'

const ErrorElement = () => {
  // Uncaught ReferenceError: path is not defined
  return <div>Dang!</div>
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<ErrorElement />}>
      <Route index element={<OpenRoute element={LandingPage} />} />

      <Route element={<ContactPage />} path="contact-us" />
      <Route element={<FaqPage />} path="faq" />
      <Route element={<AboutPage />} path="about" />
      <Route path="components">
        <Route element={<ComponentsPage />} index />
        <Route element={<OpenRoute element={LandingPage} />} path="landing" />
      </Route>

      <Route path="auth/login" element={<Login />} />
      <Route path="auth/register" element={<Signup />} />
      <Route path="auth/verify-email" element={<VerifyEmail />} />
      <Route path="auth/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="auth/reset-password" element={<ResetPasswordPage />} />
      <Route path="waitlist" element={<WaitingListPage />} />
      <Route path="privacy-policy" element={<OpenRoute element={PrivacyPolicyPage} />} />

      <Route element={<ProtectedRoute element={Main} />}>
        {mainSideNavItems.map((data) => createRoutes(data))}
        {extraSideNavItems.map((data) => createRoutes(data))}
        <Route path={'settings/profile'} element={<Settings />} />
        <Route path={'broadcast'} element={<Dashboard />} />
        <Route path={'feedback/add'} element={<AddFeedback />} />
      </Route>
    </Route>
  )
)

function createRoutes(data: SideNavItemType | Omit<SideNavItemType, 'icon'>) {
  const hasChildren = !!data.children
  const Component = data.Page!
  return hasChildren ? (
    <Route path={data.path}>
      <Route element={<Component />} index />
      {data.children?.map((childData) => createRoutes(childData))}
    </Route>
  ) : (
    <Route key={data.path} path={data.path} element={<Component />} />
  )
}
